import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function Loading() {
  return (
    <div className='m-auto w-2/3 rounded-md bg-white p-3' style={{ textAlign: '-webkit-center' }}>
      <CircularProgress />
    </div>
  );
}